import { Helmet } from "react-helmet-async";

export function MarketingHelmet({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImageUrl,
  canonicalUrl,
}: {
  title: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImageUrl?: string | null;
  canonicalUrl: string;
}) {
  const d = (description || "").trim();
  const ogT = (ogTitle || title).trim();
  const ogD = (ogDescription || d).trim();
  const ogImg = (ogImageUrl || "").trim();

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={canonicalUrl} />
      {d ? <meta name="description" content={d} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={ogT} />
      {ogD ? <meta property="og:description" content={ogD} /> : null}
      <meta property="og:url" content={canonicalUrl} />
      {ogImg ? <meta property="og:image" content={ogImg} /> : null}
    </Helmet>
  );
}

